// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

/* wrapper to allow for touch slop if we decide to add it */

.delete-button_delete-button_TC_Jk {
    display: flex;
    align-items: center;
    justify-content: center;
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
    cursor: pointer;
    transition: all 0.15s ease-out;
}

.delete-button_delete-button-visible_pzLI4 {
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;  /* Mask the icon animation */
  width: 1.75rem;
  height: 1.75rem;
  box-shadow: 0px 0px 0px 2px var(--looks-transparent);
  background-color: var(--looks-secondary);
  color: var(--ui-white);
  border-radius: 50%;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  cursor: pointer;
  transition: all 0.15s ease-out;
}

.delete-button_delete-icon_JpwUH {
    position: relative;
    margin: 0.25rem;
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
    transform-origin: 50%;
}
`, "",{"version":3,"sources":["webpack://./src/components/delete-button/delete-button.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;sDACsD;;AAEtD,+CAA+C;;AAE/C,2DAA2D;;AAE3D;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB;IACzB,eAAe;IACf,8BAA8B;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB,GAAG,4BAA4B;EAC/C,cAAc;EACd,eAAe;EACf,oDAAoD;EACpD,wCAAwC;EACxC,sBAAsB;EACtB,kBAAkB;EAClB,2DAA2D;EAC3D,yBAAyB;KACtB,sBAAsB;MACrB,qBAAqB;UACjB,iBAAiB;EACzB,eAAe;EACf,8BAA8B;AAChC;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB;IACzB,qBAAqB;AACzB","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n/* wrapper to allow for touch slop if we decide to add it */\n\n.delete-button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    cursor: pointer;\n    transition: all 0.15s ease-out;\n}\n\n.delete-button-visible {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;  /* Mask the icon animation */\n  width: 1.75rem;\n  height: 1.75rem;\n  box-shadow: 0px 0px 0px 2px var(--looks-transparent);\n  background-color: var(--looks-secondary);\n  color: var(--ui-white);\n  border-radius: 50%;\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  cursor: pointer;\n  transition: all 0.15s ease-out;\n}\n\n.delete-icon {\n    position: relative;\n    margin: 0.25rem;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    transform-origin: 50%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"delete-button": `delete-button_delete-button_TC_Jk`,
	"deleteButton": `delete-button_delete-button_TC_Jk`,
	"delete-button-visible": `delete-button_delete-button-visible_pzLI4`,
	"deleteButtonVisible": `delete-button_delete-button-visible_pzLI4`,
	"delete-icon": `delete-button_delete-icon_JpwUH`,
	"deleteIcon": `delete-button_delete-icon_JpwUH`
};
export default ___CSS_LOADER_EXPORT___;
